import Vue from 'vue';
import users from '../setup/user';
//将获取到的景区门票配置信息格式化为key-value格式
export const convertor = (ticketConfigData) => {
  let configInfo = {};
  if (Array.isArray(ticketConfigData) && ticketConfigData.length > 0) {
    for (let i = 0; i < ticketConfigData.length; i++) {
      let info = ticketConfigData[i];
      let placeCode = info.place_code; //景区代码
      let tickets = []; //存储所有门票信息
      let placeTicketInfo = {}; //存储景区相关的所有的门票信息
      let ticketWithType = {}; //存储以ticket_type为key的票种
      let ticketWithCode = {}; //存储以code为key的票种
      if (Array.isArray(info.tickets) && info.tickets.length > 0) {
        tickets = info.tickets;
        for (let j = 0; j < info.tickets.length; j++) {
          let ticketInfo = info.tickets[j];
          if (ticketInfo.ticket_type != null) {
            ticketWithType[ticketInfo.ticket_type] = ticketInfo;
          }
          if (ticketInfo.code != null) {
            ticketWithCode[ticketInfo.code] = ticketInfo;
          }
        }
      } else {
        continue;
      }
      placeTicketInfo.tickets = tickets;
      placeTicketInfo.placeCode = placeCode;
      placeTicketInfo.start_time = info.start_time;
      placeTicketInfo.end_time = info.end_time;
      placeTicketInfo.place_name = info.place_name;
      placeTicketInfo.must_bus_line = info.must_bus_line;
      placeTicketInfo.ticketsWithType = ticketWithType;
      placeTicketInfo.ticketsWithCode = ticketWithCode;
      placeTicketInfo.originTicketInfo = info; //原始的数据信息

      configInfo[placeCode] = placeTicketInfo;
    }
  }
  return configInfo;
};
export const filterSelectedTickets = (tickets) => {
  console.log('ticketinfo====>', tickets);
  let allTickets = {
    ticketCount: 0,
  };
  let allKeys = Object.keys(tickets);
  let ticketCount = 0;
  for (let i = 0; i < allKeys.length; i++) {
    let key = allKeys[i];
    let user = tickets[key];
    if (!user.tickets || user.tickets.length == 0) {
      continue;
    }
    let ticketCode = user.tickets[0].ticket_type;
    let ticketsWithType = allTickets[ticketCode];
    if (ticketsWithType == null || !Array.isArray(ticketsWithType)) {
      ticketsWithType = [];
    }
    //逻辑有点乱，原来一个人下的票种可能有几个，现在一个订单里只有一个了，因为合并成组合票了，下面这个for循环可以不要了，只有一个
    // 但是后来新加了一种班车票，是跟着门票，与组合票里的游览车有区别，可以不买
    for (let j = 0; j < user.tickets.length; j++) {
      let t = user.tickets[j];
      let newTicket = {};
      newTicket.user_name = user.user_name;
      newTicket.id = user.id;
      newTicket.id_number = user.id_number;
      newTicket.id_type = user.id_type;
      newTicket.custom_type = user.custom_type;
      newTicket.ticketName = t.ticketName;
      newTicket.code = t.ticket_type;
      newTicket.ticket_type_id = t.ticket_type_id;
      newTicket.uid = t.uid;
      newTicket.key = user.key;
      newTicket.price = t.price;
      newTicket.bus_ticket = user.bus_ticket;
      ticketsWithType.push(newTicket);

      ticketCount++;
    }
    allTickets.ticketCount = ticketCount;
    Vue.set(allTickets, ticketCode, ticketsWithType);
  }
  return allTickets;
};
export const filterSubmitTickets = (tickets) => {
  let allTickets = [];
  let allKeys = Object.keys(tickets);
  let currentUser = users.getUser();
  for (let i = 0; i < allKeys.length; i++) {
    let key = allKeys[i];
    let user = tickets[key];
    user.id = user.id_number;
    user.phone = currentUser.phone;

    if (!user.tickets || user.tickets.length == 0) {
      continue;
    }
    let newTickets = [];
    for (let j = 0; j < user.tickets.length; j++) {
      let ticket = user.tickets[j];
      let newTicket = {};
      newTicket.use_time = ticket.use_time;
      newTicket.use_end_time = ticket.use_end_time;
      newTicket.ticket_type = ticket.ticket_type;
      newTickets.push(newTicket);
    }
    if (user.bus_ticket) {
      let newTicket = {};
      if (newTickets.length > 0) {
        newTicket.use_time = newTickets[0].use_time;
        newTicket.use_end_time = newTickets[0].use_end_time;
      }
      newTicket.ticket_type = user.bus_ticket.config_code;
      newTickets.push(newTicket);
    }
    user.tickets = newTickets;

    allTickets.push(user);
  }
  console.log('提交购票内容', allTickets);
  return allTickets;
};

export const copyTickets = (tickets) => {
  let str = JSON.stringify(tickets);
  return JSON.parse(str);
};

export const calTotalPrice = (tickets) => {
  console.log('计算总额度', JSON.stringify(tickets));
  let total = 0;
  let allkeys = Object.keys(tickets);
  for (let i = 0; i < allkeys.length; i++) {
    let key = allkeys[i];
    let userInfo = tickets[key.toString()];
    let tmpTickets = userInfo.tickets;
    for (let j = 0; j < tmpTickets.length; j++) {
      let ticket = tmpTickets[j];
      total += parseFloat(ticket.price);
    }
    if (userInfo.bus_ticket) {
      total += parseFloat(userInfo.bus_ticket.price);
    }
  }
  return total;
};
//获取门票使用情况的统计信息
export const getUsedCount = (orderInfo) => {
  let count = 0; //已使用的数量
  let totalCount = 0; //总数
  let refundCount = 0; //已退票的数量
  let unUsedCount = 0;
  let expiredCount = 0; //已过期
  let getTicket = 0; //已过期
  let usersInfo = orderInfo.users_info;
  if (usersInfo && Array.isArray(usersInfo)) {
    for (let i = 0; i < usersInfo.length; i++) {
      let user = usersInfo[i];
      let tickets = user.tickets;
      if (tickets && Array.isArray(tickets)) {
        for (let j = 0; j < tickets.length; j++) {
          let ticket = tickets[j];
          let status = ticket.status;
          if (status == 3) {
            count++;
          }
          if (status == 9) {
            refundCount++;
          }
          if (status == 2) {
            unUsedCount++;
          }
          if (status == 4) {
            expiredCount++;
          }
          if (status == 5) {
            getTicket++;
          }
        }
        totalCount += tickets.length;
      }
    }
  }
  return {
    total: totalCount,
    useCount: count,
    refundCount: refundCount,
    unUsedCount: unUsedCount,
    expiredCount: expiredCount,
    getTicket: getTicket,
  };
};
